<template>
  <div class="loading"
    :class="{'primary': loadType === 'primary', 'page': loadType === 'page'}"
  >
    <rich-loading :custom-class="{'primary': loadType === 'primary', 'grey': loadType === 'grey', 'page': loadType === 'page'}"></rich-loading>
  </div>
</template>

<script>
export default {
  name: 'loading',
  props: {
    loadType: {
      type: String,
      default: 'normal'
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "~@/common/stylus/variables"
.primary {
  ::v-deep .clip-g1 g path, ::v-deep .clip-g3 g path{
    fill #fff
  }
}
.grey {
  ::v-deep .clip-g1 g path, ::v-deep .clip-g3 g path {
    fill #D6D6D6
  }
}
.loading{
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 150px
  height: 12px
  margin: 3px auto 0
  // span{
  //   display: inline-block
  //   width: 12px
  //   height: 100%
  //   margin-right: 12px
  //   border-radius: 50%
  //   background: #E0E0E0
  //   animation: load-gray 1.84s ease infinite
  // }
  // span:last-child{
  //   margin-right: 0px
  // }
  // span:nth-child(1){
  //   animation-delay:0.43s
  // }
  // span:nth-child(2){
  //   animation-delay:0.66s
  // }
  // span:nth-child(3){
  //   animation-delay:0.89s
  // }
}
.primary {
  span {
    loading-load-page-animation();
  }
}
.page {
  span {
    loading-load-page-animation();
  }
}
@keyframes load{
  0%{
      background: #FFFFFF
      transform: scale(1.33)
  }
  100%{
      background: #FAC7AA
      transform: scale(1.0)
  }
}
@keyframes load-gray{
  0%{
      background: #E0E0E0
      transform: scale(1.33)
  }
  100%{
      background: #EDEDED
      transform: scale(1.0)
  }
}
</style>
